<script>
	import { page } from "$app/stores";
</script>

<svelte:head>
	<title>Erro | TXM Business</title>
</svelte:head>

<span> Ops... Algo de errado aconteceu... </span>

<span>
	{$page.status} : {$page.error.message}
</span>
